
export default class SurveyLinkBuilder
{
    //#region Public Interface

    constructor(settings, linkRenderer, mutators = [])
    {
        this._settings = settings;
        this._linkRenderer = linkRenderer;
        this._mutators = mutators;
    }

    initialize(store)
    {
        this._store = store;
    }

    buildLink(linkConfig, className, title)
    {
        if (!linkConfig) { return undefined; }

        const EntryId = this.getEntryId();
        const SurveyUnitLabel = this.getSurveyUnitLabel();

        const linkSpec = Object.assign({ className: className }, linkConfig, { EntryId, SurveyUnitLabel });
        const link = this.getLink(linkSpec);
        if (title) { link.properties.title = title; }

        return link;
    }

    //#endregion



    //#region Helper Methods

    getLink(template)
    {
        const renderLink = this._linkRenderer.renderLink.bind(this._linkRenderer);
        const resetOverlay = () =>
        {
            this.clearRadioSelection();
            this.clearFreeformText();
            this.clearDropdownSelection();

            this._store.dispatch({ type: "HIDE_SURVEY" });
        };

        const defaultParams =  { gradingType: "Survey", gradingQueue: 2 , gradingReason: "", gradingComments: ""};

        const paramProvider = () =>
        {
            const parameters = Object.assign({}, defaultParams, template.parameters);

            parameters.entryId = this.getSurveyState()[this._settings.stateLocations.Survey.EntryId];
            parameters.SurveyUnitLabel = this.getSurveyState()[this._settings.stateLocations.Survey.SurveyUnitLabel];

            if (template.SendReason)
            {
                const reason = this.getReason();
                parameters.gradingReason = reason || "";
            }
            if (template.SendComments)
            {
                const freeformText = this.getElementByClassNameFromSurvey(this._settings.classNames.surveyFreeformText);
                parameters.gradingComments = (freeformText && freeformText.value) || "";
            }

            return parameters;
        };

        let linkSpec = Object.assign({}, template, { parameters: paramProvider }, { Handler: resetOverlay });

        linkSpec = this._mutators.reduce((props, mutate) => mutate(props), linkSpec);

        return renderLink(linkSpec);
    }

    clearRadioSelection()
    {
        const radioButtons = this.getElementByClassNameFromSurvey(this._settings.classNames.surveyRadioButtons);

        if (radioButtons)
        {
            const selected = radioButtons.querySelector('input[name = "surveyReasons"]:checked');
            if (selected) { selected.checked = false; }
        }
    }

    clearDropdownSelection(){
        const dropdown = this.getElementByClassNameFromSurvey(this._settings.classNames.surveyDropdown);

        if(dropdown){
            const selected = dropdown[dropdown.selectedIndex];
            if(selected) { selected.selected = false; }
        }
    }

    clearFreeformText()
    {
        const freeformText = this.getElementByClassNameFromSurvey(this._settings.classNames.surveyFreeformText);

        if (freeformText) { freeformText.value = ""; }
    }

    getElementByClassNameFromSurvey(className)
    {
        const survey = document.getElementById(this.getSurveyId());

        return survey.getElementsByClassName(className)[0];
    }

    getSurveyState()
    {
        const base = this._settings.stateLocations.Survey.Base;

        return this._store.getState()[base];
    }

    getSurveyId()
    {
        return this.getSurveyState()[this._settings.stateLocations.Survey.SurveyId];
    }

    getEntryId()
    {
        return this.getSurveyState()[this._settings.stateLocations.Survey.EntryId];
    }

    getSurveyUnitLabel()
    {
        return this.getSurveyState()[this._settings.stateLocations.Survey.SurveyUnitLabel];
    }

    getReason()
    {
        return this.getSurveyState()[this._settings.stateLocations.Survey.Reason];
    }

    //#endregion
}


// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/simple-feedback-overlay/src/builders/surveyLinkBuilder.js